import * as Yup from "yup";
import { getPatchOperations } from "../../../util/form";
import { dateToyyyyMMdd } from "../../../util/date";
import { patch } from "../../../api/util";
import { PrismatrixDTO } from "../../../interfaces/formDto";

export const adminPrismatrixConfig = (
  prismatrixId?: string,
  openTilDateId?: string,
  latestDateEntryId?: string,
): FormConfig<PrismatrixDTO> => {
  const query = "prismatrix";
  const queryWId = query + `/${prismatrixId}`;
  const queryWOpenTilDateId = query + `/${openTilDateId}`;
  const queryWLatestId = query + `/${latestDateEntryId}`;
  return {
    title: "prissætning",
    get: queryWId,
    postInitialFormDataQuery: queryWId,
    form: [
      {
        component: "datepicker",
        id: "periodeFraDato",
        label: "Gældende fra",
        initialValue: "",
      },
      {
        component: "textinput",
        id: "fmuKursusholdDagspris",
        initialValue: "",
        label: "Kursus Dagspris",
      },
      {
        component: "textinput",
        id: "fmuKursusholdOvernatningspris",
        initialValue: "",
        label: "Kursus Overnatningspris",
      },
      {
        component: "textinput",
        id: "fmuKursusholdAendringsGebyr",
        initialValue: "",
        label: "Kursus Ændringsgebyr",
      },
      {
        component: "textinput",
        id: "retssagsproeve",
        initialValue: "",
        label: "Retssagsprøve",
      },
      {
        component: "textinput",
        id: "abonnement",
        initialValue: "",
        label: "Abonnement",
      },
      {
        component: "textinput",
        id: "bidragTilAS",
        initialValue: "",
        label: "Bidrag Til AS",
      },
      {
        component: "textinput",
        id: "kontingentKAF",
        initialValue: "",
        label: "Kontingent KAF",
      },
      {
        component: "textinput",
        id: "asForsikringsordning",
        initialValue: "",
        label: "AS Forsikringsordning",
      },
    ],
    validationSchema: Yup.object(),
    post: (values) => {
      try {
        if (openTilDateId) {
          patch({
            query: queryWOpenTilDateId,
            body: JSON.stringify(
              getPatchOperations({
                periodeTilDatoInklusiv: values.periodeFraDato,
              }),
            ),
          });
        }
        return {
          query,
          body: {
            ...values,
            periodeFraDato: dateToyyyyMMdd(
              values.periodeFraDato as unknown as Date,
            ),
            periodeTilDatoInklusiv: "9999-12-31",
          },
        };
      } catch (error) {
        console.error(error);
        return { query: "", body: {} };
      }
    },
    patch: (values) => {
      return {
        body: JSON.stringify(getPatchOperations(values)),
        query: queryWId,
      };
    },
    delete: () => {
      return {
        query: queryWId,
      };
    },
    afterDeleteFunction: () => {
      if (latestDateEntryId) {
        try {
          patch({
            query: queryWLatestId,
            body: JSON.stringify(
              getPatchOperations({ periodeTilDatoInklusiv: "9999-12-31" }),
            ),
          });
        } catch (error) {
          console.error(error);
        }
      }
    },
  };
};
